var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: _vm.size,
        height: _vm.size,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("path", {
        attrs: {
          d:
            "M5 13.5C4.06 13.5 3.19 13.83 2.5 14.38C1.58 15.11 1 16.24 1 17.5C1 19.71 2.79 21.5 5 21.5C6.01 21.5 6.93 21.12 7.64 20.5C8.47 19.77 9 18.7 9 17.5C9 15.29 7.21 13.5 5 13.5ZM6 17.75C6 18.01 5.86 18.26 5.64 18.39L4.39 19.14C4.27 19.22 4.13 19.25 4 19.25C3.75 19.25 3.5 19.12 3.36 18.89C3.15 18.53 3.26 18.07 3.62 17.86L4.51 17.33V16.25C4.51 15.84 4.85 15.5 5.26 15.5C5.67 15.5 6 15.84 6 16.25V17.75Z",
          fill: _vm.color
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M17.25 2.42993H7.75C4.9 2.42993 3 4.32993 3 7.17993V11.6399C3 11.9899 3.36 12.2399 3.7 12.1499C4.12 12.0499 4.55 11.9999 5 11.9999C7.86 11.9999 10.22 14.3199 10.48 17.1299C10.5 17.4099 10.73 17.6299 11 17.6299H11.55L15.78 20.4499C16.4 20.8699 17.25 20.4099 17.25 19.6499V17.6299C18.67 17.6299 19.86 17.1499 20.69 16.3299C21.52 15.4899 22 14.2999 22 12.8799V7.17993C22 4.32993 20.1 2.42993 17.25 2.42993ZM15.83 10.8099H9.17C8.78 10.8099 8.46 10.4899 8.46 10.0999C8.46 9.69993 8.78 9.37993 9.17 9.37993H15.83C16.22 9.37993 16.54 9.69993 16.54 10.0999C16.54 10.4899 16.22 10.8099 15.83 10.8099Z",
          fill: _vm.color
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }